import React from 'react';
import { Map } from 'immutable';
import c from 'classnames';

import {
  ImageFromField,
} from '@uncinc/react-drupal-core';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import FadeWrapper from '../FadeWrapper';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../config/constants';


import './style.scss';

const Hero = (props) => {
  const { image, description, vertical } = props;

  const imageVertical = image.getIn(['styles', 'crop_3_4']);
  const imageFields = Map({
    [SCREEN_MOBILE]: 'entity_hero_image_mobile',
    [SCREEN_TABLET]: 'entity_hero_image_tablet',
    [SCREEN_NORMAL]: 'entity_hero_image_desktop',
    [SCREEN_WIDE]: 'entity_hero_image_desktop',
  });

  const mainClasses = c('Hero', {
    'Hero--vertical': vertical,
  });

  return (
    <div className={mainClasses}>
      <FadeWrapper duration={600} delay={200}>
        <div className="Hero__inner">
          <div className="Hero__inner__content">
            {image.get('styles') && (
              vertical ? (
                <Image
                  src={imageVertical}
                  className="Hero__image"
                />
              ) : (
                <ImageFromField
                  className="Hero__image"
                  field={image}
                  imageStyles={imageFields}
                />
              )
            )}
          </div>
          {description && (
            <div className="Hero__inner__subtext">
              {description}
            </div>
          )}
        </div>
      </FadeWrapper>
    </div>
  );
};

export default Hero;
